var _this = this;
import * as tslib_1 from "tslib";
import { onSharePointLinkDetected } from '../actions/internalActions';
import { lazyRefreshSharingTips } from 'owa-attachment-well-data';
import { addSharePointLink } from 'owa-link-data';
import { isValidGetSharingInfoResponse } from 'owa-sharing-data';
import { orchestrator } from 'satcheljs';
var refreshSharingTips;
orchestrator(onSharePointLinkDetected, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!isValidGetSharingInfoResponse) return [3 /*break*/, 3];
                addSharePointLink(actionMessage.linkId, actionMessage.sharingLinkIds, actionMessage.response);
                if (!!refreshSharingTips) return [3 /*break*/, 2];
                return [4 /*yield*/, lazyRefreshSharingTips.import()];
            case 1:
                refreshSharingTips = _a.sent();
                _a.label = 2;
            case 2:
                refreshSharingTips(actionMessage.attachmentWellViewState, actionMessage.parentItemId, actionMessage.infoBarAddHandler, actionMessage.infoBarRemoveHandler);
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=onSharePointLinkDetected.js.map